export default "__VITE_ASSET__2CI28tV2__"